import classNames from "classnames";

import styles from "./style.module.scss";

interface SeparatorProps {
  className?: any;
}
const Separator = ({ className }: SeparatorProps) => {
  return <hr className={classNames(styles.seperator, className)} />;
};

export default Separator;
